import React from 'react'

function ShopBanner() {
  return (
    <div>
      <div className="shop-banner">
      <div className="container">
          <div className="row">
              <div className="col-lg-12">
                  <div className="header-text">
                      <h1>We Provide Everything</h1>
                      <h2><em>Shop</em> now</h2>
                      
                  </div>
              </div>
          </div>
      </div>
  </div>
    </div>
  )
}

export default ShopBanner
